import script from "./tjjianmo.vue?vue&type=script&setup=true&lang=ts"
export * from "./tjjianmo.vue?vue&type=script&setup=true&lang=ts"

import "./tjjianmo.vue?vue&type=style&index=0&id=650b14ae&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650b14ae"]])

export default __exports__